import { useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import CodeMirror from "@uiw/react-codemirror";
import { html as htmlLang } from "@codemirror/lang-html";
import { EditorView } from "@codemirror/view";
import { Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { EmailCampaignReportContext } from "./index";

export function EmailCampaignReportCodeTab() {
  const { campaign } = useOutletContext<EmailCampaignReportContext>();
  const templateHtml = campaign.html || "<div></div>";

  const handleCopyCode = async () => {
    try {
      await navigator.clipboard.writeText(templateHtml);
      toast.success("Code copied to clipboard");
    } catch (error) {
      console.error("Failed to copy code:", error);
      toast.error("Failed to copy code");
    }
  };

  return (
    <div className="relative rounded-lg border overflow-hidden h-[min(70vh,720px)]">
      <div className="absolute top-2 right-2 z-10">
        <Button
          type="button"
          size="icon"
          variant="ghost"
          className="h-8 w-8 bg-background/80 shadow-sm backdrop-blur-sm"
          aria-label="Copy code"
          title="Copy code"
          onClick={() => void handleCopyCode()}
        >
          <Copy className="h-4 w-4" />
        </Button>
      </div>
      <CodeMirror
        value={templateHtml}
        height="100%"
        editable={false}
        extensions={[htmlLang(), EditorView.lineWrapping]}
        basicSetup={{
          lineNumbers: true,
          foldGutter: true,
          highlightActiveLine: false,
          bracketMatching: true,
        }}
        className="h-full text-sm"
      />
    </div>
  );
}
